import Requestor from '@/api/Requestor';
import { clientInstance } from '@/api/core';
class AuthVerificationApi extends Requestor {
    postRequestAuthVerification(data = {}) {
        return this.post({
            url: '/api/v1/auth/verification/sms/request',
            data,
        });
    }
    postCheckAuthVerification(data = {}) {
        return this.post({
            url: '/api/v1/auth/verification/sms/check',
            data,
        });
    }
}
export default new AuthVerificationApi(clientInstance);
